module.exports = __webpack_public_path__ + "img/switzerland-lung-cancer-male.e8a9860b.png";